import React, { useState, useEffect } from "react";
import DesktopIcon from "../src/img/desktop_settings.svg";
import Tapeta_01 from "./images/tapeta_01.jpg";
import Tapeta_02 from "./images/tapeta_02.jpg";
import Tapeta_03 from "./images/shutterstock_1124255354.jpg";
import Tapeta_04 from "./images/shutterstock_1654284619.jpg";
import Tapeta_05 from "./images/shutterstock_337848515.jpg";

const DesktopSettings = ({ wallpaper }) => {
  const [desktopImage, setDesktopImage] = useState();
  const [change, setChange] = useState(0);

  useEffect(() => {
    const intervalTwo = setInterval(() => {
      setChange((prevState) => prevState + 1);
    }, 5);
    if (change === 100) {
      return () => {
        clearInterval(intervalTwo);
      };
    }
  }, []);

  return (
    <>
      <div className="settings-container" style={{ opacity: change / 100 }}>
        <div className="settings-header">
          <img src={DesktopIcon} alt="desktop icon" />
          <h1>wallpaper gallery</h1>
        </div>
        <div className="desktop-pictures">
          {/* ===== */}
          {/* ===== */}
          <a
            href="#"
            onClick={() => setDesktopImage(Tapeta_01)}
            id="p-c"
            className="picture-container"
          >
            <div className="picture">
              <img src={Tapeta_01} alt="" />
            </div>
            <p className="subtitle">underwater</p>
          </a>
          {/* ===== */}
          {/* ===== */}
          <a
            href="#"
            onClick={() => setDesktopImage(Tapeta_02)}
            id="p-c"
            className="picture-container"
          >
            <div className="picture">
              <img src={Tapeta_02} alt="" />
            </div>
            <p className="subtitle">abbys</p>
          </a>
          {/* ===== */}
          {/* ===== */}
          <a
            href="#"
            onClick={() => setDesktopImage(Tapeta_03)}
            id="p-c"
            className="picture-container"
          >
            <div className="picture">
              <img src={Tapeta_03} alt="" />
            </div>
            <p className="subtitle">saturday night</p>
          </a>
          {/* ===== */}
          {/* ===== */}
          <a
            href="#"
            onClick={() => setDesktopImage(Tapeta_04)}
            id="p-c"
            className="picture-container"
          >
            <div className="picture">
              <img src={Tapeta_04} alt="" />
            </div>
            <p className="subtitle">downtown lights</p>
          </a>
          {/* ===== */}
          {/* ===== */}
          <a
            href="#"
            onClick={() => setDesktopImage(Tapeta_05)}
            id="p-c"
            className="picture-container"
          >
            <div className="picture">
              <img src={Tapeta_05} alt="" />
            </div>
            <p className="subtitle">carbon</p>
          </a>
          {/* ===== */}
          <div className="desktop-button-container">
            {/* ===== */}

            <button className="waiting" onClick={() => wallpaper(desktopImage)}>
              set desktop image
            </button>
            {/* ===== */}
            <button className="waiting" onClick={() => wallpaper()}>
              default setings
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopSettings;
